import { Typography, Box } from "@mui/material";

const EmptyData: React.FC<{ message?: string, data: any }> = ({ message, data }) => {
    return (
        <>
            {data.length === 0 &&
                <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                    <Typography variant="body1" color="textSecondary">
                        {message || "No data found"}
                    </Typography>
                </Box>}
        </>
    );
};

export default EmptyData;
